var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProvider = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50032 0.726563C2.59703 0.726563 0.229492 3.09405 0.229492 5.9974C0.229492 8.90514 2.59703 11.2682 5.50032 11.2682C8.40812 11.2682 10.7712 8.90514 10.7712 5.9974C10.7712 3.09405 8.40812 0.726563 5.50032 0.726563ZM8.10507 5.76461L7.04644 6.53328L7.45051 7.7763C7.52514 8.01787 7.44171 8.27703 7.23968 8.42199C7.03765 8.57131 6.76098 8.57131 6.55895 8.42199L5.50032 7.65332L4.4462 8.42199C4.23015 8.57486 3.97089 8.57365 3.76526 8.42199C3.56323 8.27703 3.47551 8.01787 3.55443 7.7763L3.95871 6.53328L2.90008 5.76461C2.69805 5.61526 2.61462 5.3561 2.68926 5.11892C2.7684 4.88175 2.98801 4.71923 3.2383 4.71923H4.54722L4.95128 3.47618C5.03042 3.23461 5.25004 3.07646 5.50032 3.07646H5.50483C5.75512 3.07646 5.97473 3.23461 6.05387 3.47618L6.45794 4.71923H7.76235C8.01714 4.71923 8.23676 4.88175 8.3159 5.11892C8.39053 5.3561 8.3071 5.61526 8.10507 5.76461Z",
    fill: "#DB31D0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProvider);
export default ForwardRef;